module.exports = __webpack_public_path__ + "img/PT.208bed7b.svg";